import { TabMenu } from "../TabMenu";

import * as S from "./styles";

export function TabMenuArea({ index, setIndex }) {
  return (
    <S.Container>
      <TabMenu index={index} setIndex={setIndex} />
    </S.Container>
  );
}
